function importAll(r) {
  let images = {};
  r.keys().map((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

const dymanicPathFroImage = importAll(
  require.context("../../images", false, /\.(png|jpe?g|svg)$/)
);

export default dymanicPathFroImage;
